import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IOHSetLevelValueService {
  // Signal to store the selected level as a string
  iohSelectedLevel = signal<number | string>(0);

  // Method to update the selected level
  updateIohSelectedLevel(item) {
    this.iohSelectedLevel.set(`${+item - 1}`);
  }
}
